import React from "react";
import { Button } from "@material-ui/core";
import { Typography } from "@material-ui/core";

export default function CustomButton({
  color = "secondary",
  onClick,
  padding = "10px 30px",
  margin,
  variant = "contained",
  textVariant = "button",
  size = "medium",
  title,
  className,
  style,
  type,
  disabled = false,
}) {
  return (
    <Button
      type={type}
      variant={variant}
      color={color}
      className={className}
      size={size}
      style={{
        padding: padding,
        margin: margin,
        borderRadius: 10,
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography variant={textVariant} color="inherit">
        {title}
      </Typography>
    </Button>
  );
}
